var _script, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1191_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32422 21.8268V7.69092H5.53223V21.8268H1.32422Z",
    stroke: "#FF9640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8881 2.9825V2.98252C5.8881 4.33792 4.78475 5.44137 3.42961 5.44137C2.0728 5.44137 0.96875 4.33761 0.96875 2.98252C0.96875 1.62835 2.07261 0.524902 3.42961 0.524902C4.78497 0.524902 5.88816 1.62798 5.8881 2.9825Z",
    stroke: "#FF9640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 8.48799V9.77209L13.5114 8.82611C14.2336 8.03938 15.4359 7.33301 17.0855 7.33301C19.4705 7.33301 20.7219 8.18072 21.4176 9.36033C22.1459 10.5953 22.3207 12.2817 22.3207 14.0599V21.8272H18.1209V14.9583C18.1209 13.995 18.0912 13.0247 17.7803 12.2948C17.6174 11.9125 17.3698 11.5747 16.9966 11.338C16.6263 11.1031 16.1754 10.995 15.6513 10.995C14.7161 10.995 13.9472 11.2628 13.4489 11.9776C12.9837 12.6449 12.8232 13.6134 12.8232 14.8346V21.8271H8.625V7.69127H12.6431V8.48799Z",
    stroke: "#FF9640"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1191_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.351,
    height: 22.351,
    fill: "white",
    transform: "translate(0.472656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.30c8047912364e8ead00de6577f51e25.svg";
export { ForwardRef as ReactComponent };